// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
  text-align: center;
  background-color: #f0f0f0;
}

.hidden {
  display: none;
}

#signaling {
  margin: 20px auto;
  width: 80%;
  max-width: 600px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

#signaling div {
  margin-bottom: 20px;
}

textarea {
  width: 100%;
  height: 100px;
  margin: 10px 0;
  resize: vertical;
}

button {
  padding: 10px 20px;
  margin: 5px;
  cursor: pointer;
}

#gameCanvas {
  border: 2px solid #000;
  background-color: #4CAF50; /* Green field */
}

#instructions {
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./styles.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["body {\n  font-family: Arial, sans-serif;\n  text-align: center;\n  background-color: #f0f0f0;\n}\n\n.hidden {\n  display: none;\n}\n\n#signaling {\n  margin: 20px auto;\n  width: 80%;\n  max-width: 600px;\n  background-color: #ffffff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n#signaling div {\n  margin-bottom: 20px;\n}\n\ntextarea {\n  width: 100%;\n  height: 100px;\n  margin: 10px 0;\n  resize: vertical;\n}\n\nbutton {\n  padding: 10px 20px;\n  margin: 5px;\n  cursor: pointer;\n}\n\n#gameCanvas {\n  border: 2px solid #000;\n  background-color: #4CAF50; /* Green field */\n}\n\n#instructions {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
